import moment from "moment";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../contexts/UserContext";
import { getTransactionData } from "../dao/transactions";

export default function useTransactions(date = new Date()) {
  const {user} = useContext(UserContext);

  const [transactions, setTransactions] = useState([]);
  const [income, setIncome] = useState(0);
  const [expenses, setExpenses] = useState(0);
  const [transactionsLoading, setTransactionsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const [error, setError] = useState("");
  const [refreshData, setRefreshData] = useState({});

  function fetchTransactionsData(startDate, endDate) {
    setTransactionsLoading(true);
    getTransactionData(startDate, endDate, user)
      .then((res) => {
        setTransactions(res.transactions);
        setIncome(res.income);
        setExpenses(res.expenses);
      })
      .catch((err) => {
        setHasError(true);
        setError(err.message);
      })
      .finally(() => {
        setTransactionsLoading(false);
      });
  };

  useEffect(() => {
    const startDate = moment(date).startOf('month').add(-1, 'days').format('YYYY-MM-DD');
    const endDate = moment(date).endOf('month').format('YYYY-MM-DD');

    fetchTransactionsData(startDate, endDate);
  }, [refreshData, date]);

  return [transactions, income, expenses, transactionsLoading, setRefreshData, hasError, error];
}
